import { Entity, Field } from "typegraph";

@Entity({ create: "rateItem" })
export class RateItem {
    @Field()
    entityId: string;
}



// WEBPACK FOOTER //
// ./src/panels/catalog/entities/Rating.ts